module.exports = __webpack_public_path__ + "img/onlinecourse.79191380.jpg";